import React, { FC, useEffect, useState } from "react";
import { Row, Col, Table, Pagination, Button, Space } from "antd";
import { getWarehouseAccessList } from "../../api/WarehouseAccess";
import { useGlobalState } from "../../context/Provider";
import { columns, datahelper } from "../../helpers/warehouseAccess.halper";
import { PlusCircleOutlined } from "@ant-design/icons";
import { FormattedMessage } from "react-intl";
import DeleteWarehouseAccessModal from "../../components/deleteWarehouseAccessModal";
import AddWarehouseAccessModal from "../../components/addWarehouseAccessModal";
import TableTotalCount from "../../components/tableTotalCount";

const WarehouseAccess: FC = () => {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState<number>(0);
  const [visibleAddModal, setVisibleAddModal] = useState<boolean>(false);
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [info, setInfo] = useState<any>({});
  const [page, setPage] = useState<number>(1);
  const { langState, warehouserList }: any = useGlobalState();
  const lang = langState.locale;

  useEffect(() => {
    setLoading(true);
    handleGetList();
  }, [page]);

  const handleGetList = () => {
    getWarehouseAccessList().then((res: any) => {
      setLoading(false);
      if (res.status === 200) {
        setData(res.data.items);
        setTotal(res.data.totalCount);
      }
    });
  };
  const handleDelete = (info: any) => {
    setVisibleDeleteModal(true);
    setInfo(info);
  };
  return (
    <>
      <Row gutter={[0, 24]} justify="center">
        <Col span={23}>
          <Button type="primary" onClick={() => setVisibleAddModal(true)}>
            <Space size={16}>
              <PlusCircleOutlined style={{ fontSize: "18px" }} />
              <FormattedMessage id="warehouseAccess.add" />
            </Space>
          </Button>
        </Col>
        <Col span={23}>
          <Table
            columns={columns(lang, handleDelete, warehouserList.data)}
            dataSource={datahelper(data, page)}
            size="middle"
            pagination={false}
            scroll={{ x: 1100, y: "calc(100vh - 310px)" }}
            loading={loading}
            // onChange={handleTableChange}
          />
        </Col>
        <Col span={23}>
          <Row justify="space-between" align="middle">
            <Col>
              <Pagination
                defaultCurrent={1}
                total={total}
                defaultPageSize={40}
                showSizeChanger={false}
                onChange={(number) => setPage(number)}
              />
            </Col>
            <Col>
              <TableTotalCount total={total} />
            </Col>
          </Row>
        </Col>
      </Row>

      <DeleteWarehouseAccessModal
        visible={visibleDeleteModal}
        setVisible={setVisibleDeleteModal}
        info={info}
      />

      <AddWarehouseAccessModal
        visible={visibleAddModal}
        setVisible={setVisibleAddModal}
      />
    </>
  );
};

export default WarehouseAccess;
